import { useMemo } from 'react'
import { useQuery } from 'react-query'

import {
  getScenariosTableData,
  Scenario,
  ScenariosTableQueryParams,
} from 'api/scenarios'
import { GUARDRAILS_NAMES } from 'constants/scenarios'

export const useGuardrailsList = ({
  status = 'ENABLED',
  archived = false,
  orgId = '',
}: ScenariosTableQueryParams) => {
  const {
    isLoading,
    data: scenariosListData,
    refetch,
  } = useQuery({
    queryKey: ['guardrails-list', orgId, archived],
    queryFn: () =>
      getScenariosTableData({
        page: 1,
        pageSize: 50,
        status,
        archived,
        orgId,
      }),
    select: ({ data }) => data,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    staleTime: Infinity,
    retry: false,
  })

  const memoizedGuardrails = useMemo<Scenario[]>(() => {
    const alphabetize =
      scenariosListData?.scenariosPageRows.filter((item) => {
        return item.name && GUARDRAILS_NAMES.includes(item.name)
      }) ?? ([] as Scenario[])
    return alphabetize.sort((a, b) => a.name.localeCompare(b.name))
  }, [scenariosListData?.scenariosPageRows])

  return {
    isLoading,
    guardrails: memoizedGuardrails,
    refetch,
  }
}
